import styled from "styled-components";

const TableNameRoot = styled.span`
  --link-hover-color: var(--primary-green);
  font-weight: 500;
  text-decoration: none;
  color: inherit;
  line-height: 20px;
`;

const TableNameSecondary = styled.span`
  line-height: 20px;
  font-size: 13px;
`;

const TableName = Object.assign(TableNameRoot, {
  Secondary: TableNameSecondary,
});

export default TableName;
